/* ---------------------------------------------------------------------------
   ELA TEILA — prekes puslapio ivadine eilute (tagline). 2026-09-23.

   Kam reikia. Etalone („Corven Bomber“) ivadinis sakinys parasytas kaip
   ATSKIRA pastraipa, todel ji lengva nudazyti mazomis didziosiomis.
   Daugumoje kitu prekiu ivadinis sakinys ir visas medziagu sarasas suvesti
   i VIENA pastraipa, atskirti dviem eilutes luziais (<br><br>). CSS negali
   pasiekti „tik pirmo sakinio“ pastraipos viduje.

   Ka daro sis failas. Suranda pirma prekes teksto pastraipa ir:
     • jei joje yra dvigubas luzis — viska, kas iki jo, apvynioja
       <span class="et-tagline">; likusi tekstas nepaliecamas;
     • jei dvigubo luzio nera ir pastraipoje nera paryskinto teksto —
       visa pastraipa pazymi klase et-tagline-p.
   Isvaizda daro assets/custom-pdp-tagline.css.

   Saugikliai. Nieko nedaro, jei pastraipos pradzioje jau yra paryskintas
   tekstas (reiskia, kad ivadinio sakinio ten nera). Veikia tik prekes
   puslapyje. Kalba nesvarbu — remiasi tik tekstu sandara, jokiu zodziu.
   Jokiu sekciju numeriu.

   Atsaukti — istrinti sio failo eilute is snippets/et-scroll-keep.liquid.
--------------------------------------------------------------------------- */
(function () {
  function run() {
    var form = document.querySelector('#main .product-form');
    if (!form) return;

    var block = form.querySelector(':scope > .product-form__text');
    if (!block) return;

    var p = block.querySelector(':scope > p');
    if (!p) return;

    if (p.querySelector('.et-tagline')) return;
    if (p.classList.contains('et-tagline-p')) return;

    var html = p.innerHTML;
    var m = html.match(/^([\s\S]*?)<br\s*\/?>\s*<br\s*\/?>/i);

    if (m) {
      var head = m[1];
      if (!head.replace(/<[^>]*>/g, '').trim()) return;
      if (/<strong|<b[\s>]/i.test(head)) return;
      p.innerHTML = '<span class="et-tagline">' + head + '</span>' + html.slice(head.length);
      return;
    }

    if (p.querySelector('strong, b')) return;
    p.classList.add('et-tagline-p');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
